module.exports = "precision mediump float;\n#define GLSLIFY 1\nattribute vec2 position;\nvarying vec2 uv;\nvoid main () {\n  uv = position;\n  gl_Position = vec4(2.0 * position - 1.0, 0, 1);\n}"


//////////////////
// WEBPACK FOOTER
// ./vertex.glsl
// module id = 17
// module chunks = 0